import {
  Box,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Button,
  Typography,
} from "@mui/material";

import { dataSources } from "@/components/political/dataSources";

function AreYouSureModal({ open, onClose, dataSource, filename }) {
  const source = dataSources[dataSource];
  const SourceIcon = source.icon;

  const handleCancel = () => {
    onClose(false);
  };

  const handleOk = () => {
    onClose(true);
  };

  return (
    <Dialog open={open}>
      <DialogTitle>Confirm Volunteer Data File</DialogTitle>
      <DialogContent>
        <Box>
          <Typography sx={{ marginBottom: "4px" }}>
            File name: <i>{filename}</i>
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <SourceIcon
              sx={{
                color: source.color,
                fontSize: "2rem",
                marginRight: "5px",
              }}
            />
            <span style={{ fontSize: "1.2rem", fontWeight: "500" }}>
              {source.label}
            </span>
          </Box>
          <Box sx={{ padding: "0 20px", marginTop: "6px" }}>
            <ul>
              {source.description.map((line, index) => (
                <li key={index}>{line}</li>
              ))}
            </ul>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        {/* Focus the safe (cancel) button so a keyboard Enter doesn't trigger the destructive action */}
        {/* eslint-disable-next-line jsx-a11y/no-autofocus */}
        <Button className="siteBlueOutlined" autoFocus onClick={handleCancel}>
          Take me back
        </Button>
        <Button className="siteBlue" onClick={handleOk}>
          Yes, I&apos;m sure
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AreYouSureModal;
